export const API_REDIRECT = process.env.REACT_APP_REDIRECT_URI;

const isExternal = process.env.ALLOWED_ACCESS === 'external' ||  window.location.origin !== API_REDIRECT.trim();

export const API_CONTRACTS_ADMIN = process.env.REACT_APP_API_CONTRACTS_ADMIN;
export const API_YCLICK_MASTER = isExternal
  ? process.env.REACT_APP_API_YCLICK_MASTER_EXTERNAL
  : process.env.REACT_APP_API_YCLICK_MASTER ?? '';
export const API_CERTIFICATIONS_MASTER =
  process.env.REACT_APP_API_CERTIFICATIONS_MASTER;
export const API_TOKEN_URL = process.env.REACT_APP_TOKEN_URL;
export const API_USER_INFO = process.env.REACT_APP_USER_INFO;
export const URL_SERVICIOS = isExternal
  ? process.env.REACT_APP_URL_SERVICIOS_EXTERNAL
  : process.env.REACT_APP_URL_SERVICIOS ?? '';
export const URL_CERTIFICACIONES = isExternal
  ? process.env.REACT_APP_URL_CERTIFICACIONES_EXTERNAL
  : process.env.REACT_APP_URL_CERTIFICACIONES ?? '';
export const CRYPTOJS_SECRETKEY = process.env.REACT_APP_CJSSK;
export const URL_ADMINISTRACION = isExternal 
? process.env.REACT_APP_URL_ADMINISTRACION_EXTERNAL
: process.env.REACT_APP_URL_ADMINISTRACION ?? '';
export const URL_CERTIFICACIONES_INT =
  process.env.REACT_APP_URL_CERTIFICACIONES_INT;
export const API_ADMINISTRATION = isExternal
  ? process.env.REACT_APP_API_ADMINISTRATION_EXTERNAL.trim()
  : process.env.REACT_APP_API_ADMINISTRATION.trim() ?? '';
export const CREDENTIALS_KEY = process.env.REACT_APP_CREDENTIALS_KEY;
export const API_SERVICIOS = isExternal
  ? process.env.REACT_APP_API_SERVICES_EXTERNAL
  : process.env.REACT_APP_API_SERVICES ?? '';
  export const ALLOWED_ACCESS = process.env.ALLOWED_ACCESS;
